import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"app"},[((_vm.desktop && !_vm.from) || _vm.isExceptedRoute)?_c(VMain,[(
      this.upgradeExceptionRoutes.indexOf(_vm.$route.name) === -1 &&
      !this.$store.state.user.isPro &&
      !_vm.isEmbedded &&
      this.$store.state.token &&
      !_vm.isTDP &&
      !_vm.isRegistrationFlow
    )?_c('TopProCTA'):_vm._e(),(
      _vm.isEmbedded &&
      this.outOfAppExceptionRoutes.indexOf(_vm.$route.name) === -1 &&
      !_vm.isTDP
    )?_c('TopNavbar'):_vm._e(),_c(VRow,{style:(!_vm.isEmbedded && this.fullHeightRoutes.indexOf(_vm.$route.name) === -1
      ? ''
      : 'height: 100% !important;')},[(_vm.shouldShowNavbar)?_c(VCol,{class:{'p-0': _vm.deviceSize.isMobile},attrs:{"cols":_vm.deviceSize.isMobile ? '12' : '1'}},[_c('Navbar',{staticClass:"mr-n10"})],1):_vm._e(),_c(VCol,{class:_vm.shouldShowNavbar && !_vm.deviceSize.isMobile ? 'ml-n10 pr-1' : 'pa-0',style:(_vm.deviceSize.isMobile ? 'padding-bottom: 60px;' : ''),attrs:{"cols":_vm.shouldShowNavbar && !_vm.deviceSize.isMobile ? '11' : '12'}},[(_vm.isEmbedded && !_vm.isTDP)?_c(VSpacer,{staticClass:"my-10"}):_vm._e(),_c('RouterView',{class:_vm.isEmbedded ? 'px-10' : '',attrs:{"isTDP":_vm.isTDP}})],1)],1),(this.$store.state.token && !_vm.isRegistrationFlow)?_c('HelpDesk',{attrs:{"help":_vm.helpDesk},on:{"close":function($event){_vm.helpDesk = false}}}):_vm._e(),(
      this.upgradeExceptionRoutes.indexOf(_vm.$route.name) === -1 &&
      this.$store.state.token &&
      !_vm.isEmbedded &&
      !_vm.isTDP &&
      !_vm.isRegistrationFlow && 
      !_vm.deviceSize.isMobile
    )?_c(VBtn,{class:_vm.$store.state.user.isPro ? 'help-button-for-pro' : 'help-button-no-pro',attrs:{"top":"","right":"","small":""},on:{"click":function($event){_vm.helpDesk = !_vm.helpDesk}}},[_vm._v(" "+_vm._s(_vm.$t('btnHelp'))+" "),_c(VIcon,{staticClass:"ml-2",attrs:{"x-small":""}},[_vm._v("fa-regular fa-question")])],1):_vm._e(),(_vm.deviceSize.isMobile && 
        this.upgradeExceptionRoutes.indexOf(_vm.$route.name) === -1 &&
        this.$store.state.token &&
        !_vm.isEmbedded &&
        !_vm.isTDP &&
        !_vm.isRegistrationFlow)?_c(VBtn,{staticClass:"mobile-help-btn",attrs:{"fab":"","small":"","fixed":"","bottom":"","right":"","color":"mainGreen"},on:{"click":function($event){_vm.helpDesk = !_vm.helpDesk}}},[_c(VIcon,[_vm._v("fa-regular fa-question")])],1):_vm._e()],1):(!_vm.desktop && !_vm.from && !_vm.isExceptedRoute)?_c(VMain,[_c('MobileNote')],1):_vm._e(),(_vm.from == 'verified')?_c(VMain,[_c('MagicLinkConfirmation')],1):_vm._e(),(_vm.deviceSize.isMobile && 
      this.$store.state.token &&
      !_vm.isEmbedded)?_c('div',{staticClass:"mobile-language-selector"},[_c('LanguageSelector')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }